import { useEffect, useState, CSSProperties, useRef } from 'react'
import { generateUUID, getUUID, setUUID } from 'utils/uuid'
import firebase from 'utils/firebase'
import { Login } from 'components/Login'
// import { StreamType } from 'components/Video/Video'
import { useLocation } from 'react-router-dom'
import { Header } from 'components/Header'
import { BuffInfo } from 'components/BuffInfo'
import { CUSTOM_PLAYER_CONFIG } from 'config/Buff'
import { REMOTE_FETCH_TIME, DEFAULT_REMOTE_CONFIG } from 'config/Remote'
import MediaQuery from 'react-responsive'
import rotate from 'assets/rotate.png'
import styles from './Dailymotion.module.scss'

const TARGET = process.env.REACT_APP_TARGET

const remoteConfig = firebase.remoteConfig()
remoteConfig.settings = {
  fetchTimeoutMillis: REMOTE_FETCH_TIME,
  minimumFetchIntervalMillis: REMOTE_FETCH_TIME,
}

remoteConfig.defaultConfig = DEFAULT_REMOTE_CONFIG

const videoContainerStyles: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
}
interface Props {
  vodName?: string
  showInfoColumn?: boolean
}

const getStreamOptions = (videoID: string | null, remoteOptions: any) => {
  if (videoID) {
    return remoteOptions?.VOD?.[videoID]
  }

  return remoteOptions?.LIVE
}

const Dailymotion = ({ vodName, showInfoColumn }: Props) => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const videoID = vodName || params?.get('videoID')
  const [hasUUID, setHasUUID] = useState(true)
  const [stream, setStream] = useState(null)
  // const [streamType, setStreamType] = useState(StreamType.LIVE)
  // const [videoUrl, setVideoUrl] = useState('')
  const [poster, setPoster] = useState(undefined)
  const [loadingRemote, setLoadingRemote] = useState(false)
  const [allowedVODIds, setAllowedVODIds] = useState<string[]>([])
  const widgetInstance = useRef<any>()
  const sportBuffContainer = useRef<HTMLElement>()
  const container = useRef<HTMLDivElement>(null)

  const containerBg = !showInfoColumn ? 'white' : ''
  const leftSideClass = showInfoColumn ? 'leftSide' : ''

  const getRemoteConfig = (onConfig: (id: number) => void) => {
    setLoadingRemote(true)
    return remoteConfig.fetchAndActivate().finally(() => {
      const remoteOptions = JSON.parse(
        remoteConfig.getValue(`config_${TARGET}`).asString()
      )
      const vodKeys = Object.keys(remoteOptions?.VOD || {})
      setAllowedVODIds(vodKeys)
      // setStreamType(videoID ? StreamType.VOD : StreamType.LIVE)
      const streamOptions = getStreamOptions(videoID, remoteOptions)

      // const video = streamOptions?.video_url
      const streamId = streamOptions?.stream_id
      const posterUrl = streamOptions?.poster?.url
      setStream(streamId)
      // setVideoUrl(video)
      setPoster(posterUrl)
      setLoadingRemote(false)
      if (streamId) {
        onConfig(streamId)
      }
    })
  }

  const startBuff = (_config: any) => {
    const init = async () => {
      const appendContainer = (containerToAppend: HTMLElement) => {
        sportBuffContainer.current = containerToAppend
        container.current?.appendChild?.(containerToAppend)
      }

      const destroyContainer = () => {
        if (!sportBuffContainer.current) return
        container?.current?.removeChild?.(sportBuffContainer.current)
      }

      const widgetConfig = {
        ..._config,
        appendContainer,
        destroyContainer,
        addFullScreenButton: true,
        fullScreenElement: container.current,
      }

      const instance = await window?.SportBuff.init(widgetConfig)
      widgetInstance.current = instance
    }
    if (window.SportBuff) {
      if (widgetInstance.current) {
        widgetInstance.current.destroy()
      }

      init()
    } else {
      ;(window as any).onSportBuffReady = init
    }
  }

  const initBuff = async (_config: any) => {
    try {
      await startBuff({ ..._config })
    } catch (err) {
      console.error(err)
    }
  }

  const onLoginSuccess = (token: string, uuid: string) => {
    if (!videoID) {
      setUUID(uuid)
    }
    setHasUUID(true)
    getRemoteConfig((id: number) => {
      setTimeout(() => {
        startBuff({
          ...CUSTOM_PLAYER_CONFIG,
          streamId: id,
        })
      }, 200)
    })
  }

  const checkUserAuth = async () => {
    if (vodName || !showInfoColumn) {
      const uuid = generateUUID()

      onLoginSuccess('', uuid)
      return
    }

    if (videoID) {
      setHasUUID(false)
      return
    }

    const uuid = getUUID()
    setHasUUID(!!uuid)

    if (uuid) {
      getRemoteConfig((id: number) => {
        setTimeout(() => {
          initBuff({
            ...CUSTOM_PLAYER_CONFIG,
            streamId: id,
          })
        }, 100)
      })
    }
  }

  useEffect(() => {
    checkUserAuth()
  }, [])

  const NotFound = () => {
    if (vodName && !allowedVODIds.length) return <></>

    return (
      <>
        {!loadingRemote && videoID && !allowedVODIds.includes(videoID) && (
          <>
            <p className={styles.videoNotFound}>
              No stream found with given videoID
            </p>
          </>
        )}
      </>
    )
  }

  const VideoContainer = () => {
    return (
      <>
        {!loadingRemote &&
          (!videoID || (videoID && allowedVODIds.includes(videoID))) && (
            <div
              id="buff-video-container"
              style={videoContainerStyles}
              ref={container}
            >
              {poster && <img className="adImage" alt="ad" src={poster} />}
              <div
                style={{
                  width: '1000px',
                  height: '1000px',
                }}
                id="video-container"
              >
                {' '}
                <iframe
                  title="foo"
                  frameBorder="0"
                  src="https://www.dailymotion.com/embed/video/x8ddo3n?autoplay=1"
                  width="100%"
                  height="100%"
                  allowFullScreen
                  allow="autoplay"
                >
                  {' '}
                </iframe>{' '}
              </div>
            </div>
          )}
      </>
    )
  }

  const handleRemove = () => {
    widgetInstance.current?.destroy?.()
  }

  const handleMediaQueryChange = (matches: boolean) => {
    if (matches) {
      setTimeout(() => {
        startBuff({
          ...CUSTOM_PLAYER_CONFIG,
          streamId: stream,
          force: true,
        })
      }, 1000)
    }
  }

  return (
    <>
      <Header />
      <div className={styles.content}>
        <Login onLoginSuccess={onLoginSuccess} show={!hasUUID} />

        {hasUUID && (
          <>
            <MediaQuery
              orientation="landscape"
              onChange={handleMediaQueryChange}
            >
              <MediaQuery maxDeviceWidth={1000}>
                <div className="leftSide" style={{ width: '100%' }}>
                  <VideoContainer />
                </div>
              </MediaQuery>

              <MediaQuery minDeviceWidth={1001}>
                {showInfoColumn && (
                  <div className="leftSide">
                    <BuffInfo />
                  </div>
                )}

                <div
                  className="rightSide"
                  style={{ backgroundColor: containerBg }}
                >
                  <button
                    style={{ position: 'absolute', top: 20, right: 20 }}
                    type="button"
                    onClick={handleRemove}
                  >
                    Reset
                  </button>
                  <VideoContainer />
                  <NotFound />
                </div>
              </MediaQuery>
            </MediaQuery>

            <MediaQuery
              orientation="portrait"
              onChange={handleMediaQueryChange}
            >
              <div className={leftSideClass}>
                {showInfoColumn && <BuffInfo />}
                <MediaQuery maxDeviceWidth={550}>
                  <VideoContainer />
                  <div className="rotateImage">
                    <img alt="rotate" src={rotate} />
                  </div>
                </MediaQuery>
              </div>

              <MediaQuery minDeviceWidth={551}>
                <div className="rightSide">
                  <VideoContainer />
                  <NotFound />
                </div>
              </MediaQuery>
            </MediaQuery>
          </>
        )}
      </div>
    </>
  )
}

Dailymotion.defaultProps = {
  vodName: undefined,
  showInfoColumn: true,
}

export default Dailymotion
